export const API_ENDPOINTS = {
    HOME_BANNERS: "/home-banners",
    FAQ: "/faqs",
    ABOUT: "/about-us",
    CONTACT: "/contacts",
    CONTACT_EXPORT: "/contacts/export/excel",
    USERS: "/users",
    POSTS: "/posts",
    UPLOAD: "/upload",
    CATEGORIES: "/categories",
    PRODUCTS: "/products",
    PRODUCT_PAGINATED: "/product/paginated",

    FILTERS: "/filters",
    FILTER: "/filter",
    FILTER_HOME_CARDS: "/filter/search/home_category",
    FILTER_NAVBAR_TENDENCIES: "/filter/search/product_navbar",
    FILTER_NAVBAR_CATEGORIES: "/filter/search/categoria_de_productos",
    FILTER_GRID_CARD_PORTFOLIO: "/filter/search/project_filters",
    FILTER_GRID_CARD_PRODUCT: "/filter/search/product_filters",
    FILTER_OPTIONS: "/filter-options",

    PRODUCT_FILTERS: "/product-filters",
    PROJECT_FILTERS: "/project-filters",
    SPECIFICATIONS: "/specifications",
    PRODUCT_DETAILS: "/product-details",
    PRODUCT_HELP: "/product-help",
    TAGS: "/tags",
    PRODUCT_TAGS: "/product-tags",
    PRODUCT_PHOTOS: "/product-photos",
    PRODUCT_APPLIED_PHOTOS: "/product-applied-photos",
    PRODUCT_OPTIONS: "/product-options",
    PRODUCT_FROM_CATEGORIES: "/products/category/",
    BLOGS: "/blogs",
    BLOGS_SLUG: "/blogs/slug",
    BLOG_CONTENTS: "/blog-contents",
    BLOG_COMMENTS: "/blog-comments",
    BLOG_IMAGES: "/blog-images",
    BLOG_SLIDE_SECTIONS: "/blog-slide-sections",
    FEATURES: "/features",
    CLIENTS: "/clients",
    BLOG_SLIDER_IMAGES: "/blog-slider-images",
    PROJECTS: "/projects",
    PROJECT_PAGINATED: "/project/paginated",
    WIDGETS: "/widgets",
    FLOOR_PLANS: "/floor-plans",
    FLOOR_PLAN_DETAILS: "/floor-plan-details",
    MEDIA_ITEMS: "/media-items",
    HISTORIES: "/histories",
    PRODUCT_USED: "/product-used",
    STORE_INFORMATION: "/store-information",
    HOME_SECONDARY_CATEGORIES: "/home-secondary-categories",
    HOME_PRODUCTS: "/home-products",
    HOME_MAIN_CATEGORIES: "/home-main-categories",
    HOME_MAIN_FILTERS: "/home-main-categories",
};